import styled from 'styled-components';

import colors from 'styles/colors';

export const FormItemStyled = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

export const FormInputBoxStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
`;

export const LabelStyled = styled.label`
  padding-inline: 8px;
  width: 100%;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: ${colors.brand_1};
  text-align: left;
  white-space: nowrap;
  text-transform: uppercase;
`;

export const InputStyled = styled.input`
  padding: 8px;
  width: 100%;
  border: 1px solid ${colors.gray_scale3};
  border-radius: 4px;
  font-size: 16px;
  line-height: 1.5;
  height: 40px;
  outline: none;

  &:focus {
    border-color: ${colors.brand_2};
  }
`;

export const FormMessageBoxStyled = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  column-gap: 16px;
  padding-inline: 8px;
  width: 100%;
  min-width: 0;
  font-size: 14px;
  line-height: 20px;
`;

export const FormMessageGroupStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 8px;
`;

export const FormMessageStyled = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
  text-align: left;
`;

export const CharCountStyled = styled.div<{ $isLimit?: boolean }>`
  justify-self: flex-end;
  flex-shrink: 0;
  margin-left: auto;
  text-align: right;
  color: ${({ $isLimit }) => ($isLimit ? colors.error : colors.gray_scale3)};
`;

export const FormItemActionsStyled = styled.div`
  margin-top: 20px;
`;
